var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tree-node-wrapper",
      class: [{ opened: _vm.isOpened() }, { leaf: !_vm.isParent }],
      attrs: { "data-id": _vm.treeData.id, "data-type": _vm.treeData.type },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.onNodeClick($event)
        },
        contextmenu: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onNodeRightClick($event)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "tree-node-inner",
          class: [{ active: _vm.isActive() }, _vm.levelClass],
          attrs: { title: _vm.treeData.name },
        },
        [
          _c("div", { staticClass: "bg" }),
          _vm._v(" "),
          _c("span", { staticClass: "tree-node-content" }, [
            _vm.isParent
              ? _c("i", {
                  staticClass: "fa fa-caret-right caret",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleNodeOpen($event)
                    },
                  },
                })
              : _vm._e(),
            _c("span", { staticClass: "handler" }, [
              _c("i", { staticClass: "fa-fw", class: _vm.typeIcon }),
              _vm._v(_vm._s(_vm.treeData.name)),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.treeData.children
        ? _c(
            "ul",
            { style: _vm.openedHeight, attrs: { id: _vm.treeNodeClass } },
            [
              _c(
                "draggable",
                {
                  staticClass: "tree-node",
                  attrs: {
                    list: _vm.treeData.children,
                    element: "li",
                    options: _vm.options,
                    move: _vm.handleMove,
                    "data-id": _vm.treeData.id,
                    "data-type": _vm.treeData.type,
                  },
                  on: { start: _vm.handleStart, end: _vm.handleEnd },
                },
                _vm._l(_vm.treeData.children, function (node) {
                  return _c("treenode", {
                    key: node.id,
                    attrs: {
                      treeData: node,
                      options: _vm.options,
                      level: _vm.nextLevel,
                      icons: _vm.icons,
                      sortHandler: _vm.sortHandler,
                      moveHandler: _vm.moveHandler,
                      clickHandler: _vm.clickHandler,
                      rightClickHandler: _vm.rightClickHandler,
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }